module.exports = __webpack_public_path__ + "static/img/result_ls_lens_down_angle.f817fd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_lens_down_angle.jpg
// module id = UtM2
// module chunks = 3